import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLinkItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { Button } from '@shared/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faEye, faRedo, faExternalLinkAlt } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import { ImportHistoryItem } from '../../models/ImportHistoryModel';

interface ImportHistoryActionsProps {
  item: ImportHistoryItem;
  onViewDetails: (item: ImportHistoryItem) => void;
  onRetry: (item: ImportHistoryItem) => void;
}

export const ImportHistoryActions = ({ item, onViewDetails, onRetry }: ImportHistoryActionsProps) => {
  const { t } = useTranslation('shopsModule');

  const isFailed = item.status === 'failed';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
          <FontAwesomeIcon icon={faEllipsisV} className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={() => onViewDetails(item)} className="cursor-pointer">
          <FontAwesomeIcon icon={faEye} className="mr-2 h-3.5 w-3.5" />
          {t('importHistory.actions.viewDetails', 'Ver detalles')}
        </DropdownMenuItem>

        {isFailed && (
          <DropdownMenuItem onClick={() => onRetry(item)} className="cursor-pointer text-primary">
            <FontAwesomeIcon icon={faRedo} className="mr-2 h-3.5 w-3.5" />
            {t('importHistory.actions.retry', 'Reintentar')}
          </DropdownMenuItem>
        )}

        {item.order_id && (
          <DropdownMenuLinkItem to={`/orders/view/${item.order_id}`} className="cursor-pointer">
            <FontAwesomeIcon icon={faExternalLinkAlt} className="mr-2 h-3.5 w-3.5" />
            {t('importHistory.actions.viewOrder', 'Ver pedido')}
          </DropdownMenuLinkItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
